import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../images/circle-info-regular-full.svg'


function Description ({ localDescription, setLocalDescription }) {
  const handleDescriptionChange = e => {
    const { name, value } = e.target
    setLocalDescription(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <section className={styles.descriptionSection}>
      <h1 className={styles.descriptionTitle}>Description</h1>
      <div className={styles.descriptionInputContainer}>
        <div className={styles.descriptionInputWrapper}>
          <div className={styles.inlineLabel}>
            <label className={styles.descriptionLabel} htmlFor='description'>
              Description text
            </label>
            <Tooltip
              title='Filter by products whose description contains this text.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Description help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            placeholder='Text'
            className={styles.descriptionInput}
            type='text'
            id='value'
            name='value'
            autoComplete='off'
            value={localDescription?.value || ''}
            onChange={handleDescriptionChange}
          />
        </div>
      </div>
    </section>
  )
}

export default Description
